// TODO: make this JS readable.

$(document).on('click', '.js-cancellation-interstitial__reason', function() {
  $('.js-cancellation-interstitial__support-textarea').addClass('dc-u-d-none');
  if($(this).hasClass('cancellation-interstitial__reason--active')) {
    $(this).removeClass('cancellation-interstitial__reason--active');
    $('.js-cancellation-interstitial__buttons button').attr('disabled', 'true');
  } else {
    $('.js-cancellation-interstitial__reason').removeClass('cancellation-interstitial__reason--active');
    $('.js-cancellation-interstitial__reason--other').removeClass('cancellation-interstitial__reason--active');
    $(this).addClass('cancellation-interstitial__reason--active');
    $('.js-cancellation-interstitial__buttons button').removeAttr('disabled', 'false');
  }
});

$(document).on('click', '.js-cancellation-interstitial__reason--other', function() {
  if($(this).hasClass('cancellation-interstitial__reason--active')) {
    $(this).removeClass('cancellation-interstitial__reason--active');
    $('.js-cancellation-interstitial__buttons button').attr('disabled', 'true');
    $('.js-cancellation-interstitial__support-textarea').addClass('dc-u-d-none');
  } else {
    $('.js-cancellation-interstitial__reason').removeClass('cancellation-interstitial__reason--active');
    $('.js-cancellation-interstitial__support-textarea').removeClass('dc-u-d-none');
    $('.js-cancellation-interstitial__support-textarea').focus();
    $(this).addClass('cancellation-interstitial__reason--active');
    if($('.js-cancellation-interstitial__support-textarea').val().trim().length == 0) {
      $('.js-cancellation-interstitial__buttons button').attr('disabled', 'true');
    } else {
      $('.js-cancellation-interstitial__buttons button').removeAttr('disabled', 'false');
    }
  }
});

$(document).on('keyup', '.js-cancellation-interstitial__support-textarea', function() {
  if($(this).val().trim().length == 0) {
    $('.js-cancellation-interstitial__buttons button').attr('disabled', 'true');
  } else {
    $('.js-cancellation-interstitial__buttons button').removeAttr('disabled', 'false');
  }
});

$('.js-cancellation-interstitial__primary--cancel').on('click', function(e) {
  e.preventDefault();
  $('#cancellationFlowCancelModal').modal();
});

$('.js-cancellation-interstitial__primary--pause').on('click', function(e) {
  e.preventDefault();
  $('#cancellationFlowPauseModal').modal();
});

$('.js-cancellation-interstitial__submitform').on('click', function(e) {
  e.preventDefault();
  var monthlyOrYearly = $('.js-monthly-or-yearly').val();
  var reason = $('.cancellation-interstitial__reason--active').text();
  if(reason == $('.js-cancellation-interstitial__reason--other').text()) {
    reason = $('.js-cancellation-interstitial__support-textarea').val();
  }
  window.snowplow('trackStructEvent', 'cancellation', 'submit', monthlyOrYearly, reason, '0.0');
  $('.js-cancellation-interstitial__form').submit();
});

$(document).on('change', '.js-cancellation-interstitial__radio', function() {
  if($(this).val() == 'forever') {
    $('.js-cancellation-interstitial__subheader--pause').addClass('dc-u-d-none');
    $('.js-cancellation-interstitial__subheader--cancel').removeClass('dc-u-d-none');
    $('.js-cancellation-interstitial__primary--pause').addClass('dc-u-d-none');
    $('.js-cancellation-interstitial__primary--cancel').removeClass('dc-u-d-none');
    $('.js-cancellation-interstitial__reasons-box').removeClass('dc-u-d-none');
    if($('.js-cancellation-interstitial__reason').hasClass('cancellation-interstitial__reason--active')) {
      $('.js-cancellation-interstitial__buttons button').removeAttr('disabled');
    } else if($('.js-cancellation-interstitial__reason--other').hasClass('cancellation-interstitial__reason--active')) {
      if($('.js-cancellation-interstitial__support-textarea').val().trim().length == 0) {
        $('.js-cancellation-interstitial__buttons button').attr('disabled', 'true');
      } else {
        $('.js-cancellation-interstitial__buttons button').removeAttr('disabled');
      }
    } else {
      $('.js-cancellation-interstitial__buttons button').attr('disabled', 'true');
    }
  } else {
    $('.js-cancellation-interstitial__subheader--cancel').addClass('dc-u-d-none');
    $('.js-cancellation-interstitial__subheader--pause').removeClass('dc-u-d-none');
    var months = $(this).val();
    months = months == '1' ? months + " month" : months + " months";
    monthsTitlecase = months.replace('month', 'Month');
    $('.js-cancellation-interstitial__months').text(months);
    $('.js-cancellation-interstitial__months--titlecase').text(monthsTitlecase);
    $('.js-cancellation-interstitial__primary--cancel').addClass('dc-u-d-none');
    $('.js-cancellation-interstitial__primary--pause').removeClass('dc-u-d-none');
    $('.js-cancellation-interstitial__reasons-box').addClass('dc-u-d-none');
    $('.js-cancellation-interstitial__buttons button').removeAttr('disabled', 'false');
  }
});
